import { Col, Divider, Form, Row } from 'antd';
import React, { useEffect } from 'react';
import CustomInputField from '../atoms/CustomInputField';
import FormField from '../molecules/FormField';
import CustomSelectBox from '../atoms/CustomSelectBox';
import CustomButton from '../atoms/CustomButton';
import { regexOnNumberGraterThanZero, regexOnNumberGraterThanZeroOrEqualToZero } from '../utils';

const POItemModal = ({ poForm, modalFormData, purchaseUnitList, afterCloseModal, handleSubmitItemModal }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (modalFormData !== undefined) {
      form.setFieldsValue({
        productCost: modalFormData.productCost,
        taxType: modalFormData.taxType,
        igst: modalFormData.igst,
        sgst: modalFormData.sgst,
        cgst: modalFormData.cgst,
        purchaseUnitID: modalFormData.purchaseUnitID,
        discount: modalFormData.discount,
        discountType: modalFormData.discountType,
      });
    }
  }, [modalFormData]);

  const handleSubmitModal = (data) => {
    handleSubmitItemModal(
      data,
      modalFormData.productVariationID,
      poForm ? modalFormData.receivingQTY : modalFormData.orderQTY,
    );
  };

  return (
    <Form layout='vertical' onFinish={handleSubmitModal} name='create_purchase_modal' form={form}>
      <Row gutter={24}>
        <Col span={12}>
          <FormField
            label='Product Cost'
            name='productCost'
            rules={[{ required: true, message: 'Please enter product cost!' }, regexOnNumberGraterThanZero]}
          >
            <CustomInputField type='text' size='large' placeholder='Prodcut Cost' />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Tax Type' name='taxType' rules={[{ required: true, message: 'Select tax type!' }]}>
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a tax type'
              optionFilterProp='label'
              options={[
                {
                  value: 'Exclusive',
                  label: 'Exclusive',
                },
                {
                  value: 'Inclusive',
                  label: 'Inclusive',
                },
              ]}
            />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField
            label='IGST'
            name='igst'
            rules={[{ required: true, message: 'Please enter IGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
          >
            <CustomInputField type='text' placeholder='IGST' size='large' addonAfter={'%'} />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField
            label='SGST'
            name='sgst'
            rules={[{ required: true, message: 'Please enter SGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
          >
            <CustomInputField type='text' placeholder='SGST' size='large' addonAfter={'%'} />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField
            label='CGST'
            name='cgst'
            rules={[{ required: true, message: 'Please enter CGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
          >
            <CustomInputField type='text' placeholder='CGST' size='large' addonAfter={'%'} />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Discount Type' name='discountType'>
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a discount type'
              optionFilterProp='label'
              options={[
                {
                  value: 'Percentage',
                  label: 'Percentage',
                },
                {
                  value: 'Fixed',
                  label: 'Fixed',
                },
              ]}
            />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField label='Discount' name='discount' rules={[regexOnNumberGraterThanZeroOrEqualToZero]}>
            <CustomInputField type='text' placeholder='Discount' size='large' />
          </FormField>
        </Col>
        <Col span={12}>
          <FormField
            label='Purchase Unit'
            name='purchaseUnitID'
            rules={[{ required: true, message: 'Select purchase unit!' }]}
          >
            <CustomSelectBox size='large' showSearch placeholder='Select a purchase unit' options={purchaseUnitList} />
          </FormField>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Col span={4}>
          <CustomButton type='primary' htmlType='submit' size='large' block>
            Save
          </CustomButton>
        </Col>
        <Col span={4}>
          <CustomButton type='default' size='large' onClick={afterCloseModal} block>
            Cancel
          </CustomButton>
        </Col>
      </Row>
    </Form>
  );
};

export default POItemModal;
